import {
  GET_LENDERS,
  GET_LENDERS_SUCCESS,
  GET_LENDERS_FAILURE,
  GET_LENDER,
  GET_LENDER_SUCCESS,
  GET_LENDER_FAILURE,
} from './constants';
// Get Lenders
export const getLenders = () => ({
  type: GET_LENDERS,
  payload: {},
});

export const getLendersSuccess = (lenders) => ({
  type: GET_LENDERS_SUCCESS,
  payload: lenders,
});

export const getLendersFailure = (error) => ({
  type: GET_LENDERS_FAILURE,
  payload: { message: error },
});

//Get Lender (Individual Lender)
export const getLender = (lenderId) => ({
  type: GET_LENDER,
  payload: { lenderId },
});

export const getLenderSuccess = (lender) => ({
  type: GET_LENDER_SUCCESS,
  payload: lender,
});

export const getLenderFailure = (error) => ({
  type: GET_LENDER_FAILURE,
  payload: { message: error },
});